import React, { useState, useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import {
  GET_ALERTS_BY_PAGESIZE_AND_PAGE_NUMBER,
  SUBSCRIBE_TO_ALERT_ADDED,
  MARK_ROOM_ALERT_AS_READ,
  MARK_ROOM_ALERT_AS_UNREAD
} from 'graphql/service';
import { debouncedErrorMessage } from 'utils/messageUtil';

const useAlerts = () => {

  const pageSize = 15
  const [offset, setOffset] = useState(0)
  const [alerts, setAlerts] = useState([])
  const { loading, data, fetchMore, subscribeToMore } = useQuery(GET_ALERTS_BY_PAGESIZE_AND_PAGE_NUMBER,
    {
      fetchPolicy: 'cache-first',
      variables: {
        pageSize: pageSize,
        pageNumber: 1,
        showRead: true,
        orderBy: {
          field: "createdAt",
          direction: "desc"
        }
      },
      onCompleted: (data) => {
        if(data && data.allRoomAlerts) {
          setAlerts(data.allRoomAlerts)
        }
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  )
  
  useEffect(() => {
    if (data) {
      const unsubscribe = subscribeToMore({
        document: SUBSCRIBE_TO_ALERT_ADDED,
        updateQuery: (prev,{ subscriptionData }) => {
          if (!subscriptionData.data?.roomAlertAdded) return 
          const newAlert = subscriptionData.data.roomAlertAdded;
          if (prev.allRoomAlerts?.some(alert => alert.alertId === newAlert.alertId)) {
            return prev;
          } else {
            setOffset(offset + 1)
          }

          return {
            ...prev,
            allRoomAlerts: [newAlert,...(prev.allRoomAlerts || [])],
          }
        },
        onError: (error) => {
          console.error("[SUB ERROR PAYLOAD]", error)
        }
      });

      return () => {
        unsubscribe();
      };
    }
  }, [subscribeToMore]);

  const [markRoomAlertAsRead] = useMutation(MARK_ROOM_ALERT_AS_READ, {
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message
        if(error.message.includes('Validation')) {
            content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
        }
        debouncedErrorMessage(content)
      }
    }
  });

    const [markRoomAlertAsUnread] = useMutation(MARK_ROOM_ALERT_AS_UNREAD, {
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message
        if(error.message.includes('Validation')) {
            content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
        }
        debouncedErrorMessage(content)
      }
    }
  });

  return {
    markRoomAlertAsRead,
    markRoomAlertAsUnread,
    fetchMore,
    pageSize,
    offset,
    setOffset,
    loading,
    alerts,
    setAlerts,
  }
}

export default useAlerts
